module.exports = __webpack_public_path__ + "img/com.aeg.scale.2cf3c503.webp";